// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DaMvmu7nIzPneG {
  display: none;
}
.xFvhqhjs5Kc6GV:hover .DaMvmu7nIzPneG {
  display: inline-block;
}
.efkX5p3GNPLWaA {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.tzNeaCbaATrE8a {
  margin-right: var(--ds-space-050, 4px);
}
.DeB_YZayTLAXDU {
  margin-right: var(--ds-space-075, 6px);
  font-weight: var(--ds-font-weight-bold, bold);
}
.l4lQedPGf8KN1w {
  margin-right: var(--ds-space-025, 2px);
}
.k0CzrlJuI35cY8 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-050, 4px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.k0CzrlJuI35cY8 a {
  color: var(--ds-text-subtle, #44546f);
}
.rHlYGFm93Wv4G0 {
  margin-right: var(--ds-space-025, 2px);
}
.AQfCWIJ7FyxQja {
  margin-top: var(--ds-space-200, 16px);
}
.xFvhqhjs5Kc6GV {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-050, 4px);
}
.xFvhqhjs5Kc6GV.HJBpyIBh4YEkz4 {
  width: calc(100% - 40px);
}
.xFvhqhjs5Kc6GV.HJBpyIBh4YEkz4 .l4lQedPGf8KN1w {
  cursor: pointer;
}
.xFvhqhjs5Kc6GV.HJBpyIBh4YEkz4 .DeB_YZayTLAXDU {
  font-weight: unset;
}
`, ""]);
// Exports
export var copyLinkWrapper = `DaMvmu7nIzPneG`;
export var wrapper = `xFvhqhjs5Kc6GV`;
export var editedMessage = `efkX5p3GNPLWaA`;
export var copiedCommentMessageWrapper = `tzNeaCbaATrE8a`;
export var commentMessageWrapper = `DeB_YZayTLAXDU`;
export var commentWrapper = `l4lQedPGf8KN1w`;
export var footerWrapper = `k0CzrlJuI35cY8`;
export var reactionPiles = `rHlYGFm93Wv4G0`;
export var deleteButton = `AQfCWIJ7FyxQja`;
export var boardComment = `HJBpyIBh4YEkz4`;
export default ___CSS_LOADER_EXPORT___;
